import { render, staticRenderFns } from "./NavBarComp.vue?vue&type=template&id=5024bb39&scoped=true&"
import script from "./NavBarComp.vue?vue&type=script&lang=js&"
export * from "./NavBarComp.vue?vue&type=script&lang=js&"
import style0 from "./NavBarComp.vue?vue&type=style&index=0&id=5024bb39&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5024bb39",
  null
  
)

export default component.exports